import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { AvatarsModule } from '®shared/avatars';
import { CurrentUserModule } from '®shared/current-user';
import { UriModule } from '®shared/url-utils';

import { NavbarComponent } from './navbar.component';

@NgModule({
  imports: [
    CommonModule,
    AvatarsModule,
    BsDropdownModule,
    CollapseModule,
    CurrentUserModule,
    LayoutModule,
    UriModule,
    RouterModule,
  ],
  declarations: [NavbarComponent],
  exports: [NavbarComponent],
})
export class NavbarModule {}
